/**
 * Splits this stream into multiple streams based on each predicate function
 * given.
 *
 * @param  {Array<function>} filters
 * @return {RxRlink.Observable[]}
 */

module.exports = function splitBy (filters) {
  return filters.map(filterFn => this.filter(filterFn));
};



// WEBPACK FOOTER //
// ./lib/rlink-rx/splitBy.js